(function () {
    "use strict";

    angular
        .module("UndergroundWebApp")
        .controller("DeviceEventController", DeviceEventController);

    DeviceEventController.$inject = [
        "$q",
        "$rootScope",
        "$scope",
        "filterStateService",
        "deviceEventService",
        '$translate',
        '$kWindow',
        '$filter',
        '$timeout',
        'kendoGridUtility',
    ];

    function DeviceEventController(
        $q,
        $rootScope,
        $scope,
        filterStateService,
        deviceEventService,
        $translate,
        $kWindow,
        $filter,
        $timeout,
        kendoGridUtility
    ) {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const deviceExternalId = urlParams.get('externalId');

        let events = [];
        
        $scope.serial = urlParams.get('serial');
        $scope.from = urlParams.get('from');

        const eventTypes = ['batteryEvents', 'ranEvents', 'modemEvents', 'openAccessEvents'];

        const localizedFilename = $translate.instant(
            "DEVICE_EVENTS_EXCEL_EXPORT_FILENAME"
        );
        $scope.excelFileName = `${localizedFilename}.xls`;

        $scope.filter = {
            from: (() => {
                const d = new Date();
                d.setDate(d.getDate() - 3);
                return d;
            })(),
            to: new Date(),
            category: 'battery',
            limit: 200,
        };

        $scope.toggleCategory = function (cat) {
            $scope.filter.category = cat;
            $scope.applyFilters();
        };

        $scope.$watchGroup(["filter.from", "filter.to"], function () {
            $scope.validateDateRange();
        });

        $scope.exportToExcel = exportToExcel;

        $scope.validateDateRange = function () {
            const from = $scope.filter.from;
            const to = $scope.filter.to;

            $scope.dateRangeError = "";

            if (!from || !to) {
                return;
            }

            if (from > to) {
                $scope.dateRangeError = $translate.instant('DEVICE_EVENTS_INVALID_INTERVAL');
                return;
            }

            const oneDay = 24 * 60 * 60 * 1000;
            const diffDays = Math.abs((to - from) / oneDay);

            if (diffDays > 31) {
                $scope.dateRangeError = $translate.instant('DEVICE_EVETS_TOO_BIG_INTERVAL');
            }
        };

        $scope.applyFilters = function () {
            fetchDeviceEvents();
        }


        $scope.deviceEventsGridOptions = {
            dataSource: {
                transport: {
                    read: readDeviceEvents,
                },
                pageSize: 70,
                sort: filterStateService.getSortFromQueryString(),
                filter: filterStateService.getFilterFromQueryString(),
            },
            pageable: {
                refresh: true,
                pageSizes: [20, 50, 100, 200],
                buttonCount: 5
            },
            columns: [
                {
                    field: "createdAt",
                    title: $translate.instant(
                        "DEVICE_EVENTS_EVENT_CREATED"
                    ),
                    template: function(dataItem) {
                        var dt = kendoGridUtility.getLocalDateCell(dataItem.createdAt);
                        return kendo.toString(dt, $translate.instant("G_DEFAULT_DATE_FORMAT"));
                    },
                    width: "auto",
                    lockable: false,
                },
                {
                    field: "eventType",
                    title: $translate.instant('DEVICE_EVENTS_EVENT_TYPE'),
                    width: 'auto',
                    lockable: false,
                },
                {
                    field: 'info',
                    filterable: false,
                    sortable: false,
                    title: ' ',
                    width: 30,
                    template: `<div><i class="fa fa-1-5x fa-info fa-fw" ng-click="openInfoModal(dataItem)" aria-hidden="true"></i></div>`,
                    locked: true,
                    lockable: false
                },
            ],
            scrollable: {
                virtual: true,
            },
            sortable: true,
            filterable: true,
            noRecords: true,
            selectable: false,
            resizable: true,
            sort: filterStateService.storeGridSortInQueryString,
            filter: filterStateService.storeGridFilterInQueryString,
            groupable: false,
            excel: {
                fileName: $scope.excelFileName,
                filterable: true,
                allPages: true
            },
            excelExport: deviceEventsGridExcelExport,
        };

        function getGridDataFromResponse(data) {
            const gridData = [];
            eventTypes.forEach(type => {
                data[type].forEach((event) => {
                    event.eventType = event.partitionKey.split('_')[1];;
                    gridData.push(event);
                })
            })
            return gridData;
        }

        function initController() {
            fetchDeviceEvents();
        }

        function readDeviceEvents(e) {
            e.success(events);
        }

        $scope.openInfoModal = function(event) {
            const eventCreated = new Date(event.createdAt);
            const formattedDate = $filter('date')(eventCreated, $translate.instant("G_DEFAULT_DATE_FORMAT"));
            $kWindow.open({
                options: {
                    modal: true,
                    movable: false,
                    title: `${getEventTitle(event.eventData)} - ${formattedDate}`,
                    resizable: false,
                    width: 534,
                    visible: false
                },
                templateUrl: 'app/deviceEvents/deveiceEventInfoModal/device-event-info-modal-view.html',
                windowTemplateUrl: 'app/shared/modal-base.html',
                controller: 'DeviceEventInfoModalController',
                resolve: {
                    event: () => event,
                }
            });
        }

            function getEventType(eventData) {
                if (eventData.battery) return "Battery";
                if (eventData.ran) return "RAN";
                if (eventData.modem) return "Modem";
                if (eventData.openAccess) return "OpenAccess";
                return "Unknown";
            };

            function getEventTitle (eventData) {
                switch (getEventType(eventData)) {
                    case "Battery":
                        return $translate.instant('DEVICE_EVENTS_BATTERY_EVENT');
                    case "RAN":
                        return $translate.instant('DEVICE_EVENTS_RAN_EVENT');
                    case "Modem":
                        return $translate.instant('DEVICE_EVENTS_MODEM_EVENT');
                    case "OpenAccess":
                        return $translate.instant('DEVICE_EVENTS_OPEN_ACCESS_EVENT');
                    default:
                        return $translate.instant('DEVICE_EVENTS_INFO_EVENT_DETAILS');
                }
            };

        function exportToExcel() {
            alert($translate.instant('ACCESS_CONTROL_ITEMS_OVERVIEW_CONTROLLER_EXPORT_ALERT'));
            $scope.deviceEventsGrid.saveAsExcel();
        }

        function deviceEventsGridExcelExport(e) {
            const fileName = $translate.instant('DEVICE_EVENTS_EXCEL_EXPORT_FILENAME');
            e.workbook.fileName = `${fileName} ${kendo.toString(new Date, 'ddMMyyyy_HHmmss')}.xlsx`;
            const filteredSheet = deleteEmptyColumns(e.workbook.sheets[0]);
            e.workbook.sheets[0] = filteredSheet;
            const columnWidths = this.element.find('.k-grid-header colgroup col');

            for (let i = 0; i < e.workbook.sheets[0].columns.length; i++) {
                if ($(columnWidths[i]).attr('style')) {
                    e.workbook.sheets[0].columns[i].width = 160;
                } else {
                    e.workbook.sheets[0].columns[i].width = 16;
                }
            }
        }

        function deleteEmptyColumns(table) {
            const rows = table.rows;
            const columns = table.columns;
          
            // Find the indices of the columns with empty titles in the header row
            const headerRow = rows.find(row => row.type === 'header');
            const indicesToDelete = headerRow.cells.reduce((acc, cell, index) => {
              if (cell.value.trim() === '') {
                acc.push(index);
              }
              return acc;
            }, []);
          
            // Remove the cells with the found indices from all data rows
            rows.forEach(row => {
              if (row.type === 'data') {
                indicesToDelete.slice().reverse().forEach(index => row.cells.splice(index, 1));
              }
            });
          
            // Remove the cells with the found indices from the header row
            indicesToDelete.reverse().forEach(index => headerRow.cells.splice(index, 1));
          
            // Update column widths and other properties after deletion
            indicesToDelete.forEach(index => {
              columns.splice(index, 1);
            });
          
            // Update the filter range (if applicable)
            const filter = table.filter;
            filter.to -= indicesToDelete.length;
          
            return table;
          }

          function generateDynamicColumns(events) {
    const dynamicFields = new Set();

    events.forEach((event) => {
        const d = event.eventData;
        if (!d) return;

        if (d.battery?.status) {
            dynamicFields.add("eventData.battery.status.nom_v");
            dynamicFields.add("eventData.battery.status.min_v");
            dynamicFields.add("eventData.battery.status.temp");
        }

        if (d.ran?.event?.time) {
            dynamicFields.add("eventData.ran.event.time");
        }

        if (d.ran?.event?.range?.rows) {
            dynamicFields.add("eventData.ran.event.range.rows");
        }

        if (d.modem?.ueStats) {
            dynamicFields.add("eventData.modem.ueStats.time");
            dynamicFields.add("eventData.modem.ueStats.snr");
            dynamicFields.add("eventData.modem.ueStats.rsRp");
            dynamicFields.add("eventData.modem.ueStats.rsRq");
            dynamicFields.add("eventData.modem.ueStats.temp");
        }

        if (d.access?.event?.origin?.nfc) {
            d.access.event.origin.nfc.nfcUid =
                event.eventData?.access?.event?.origin?.nfc?.uid || "";

            dynamicFields.add("eventData.access.event.time");
            dynamicFields.add("eventData.access.event.outcome");
            dynamicFields.add("eventData.access.event.origin.nfc.valid");
            dynamicFields.add("eventData.access.event.origin.nfc.nfcUid");
        }
    });

    const timeFields = new Set([
        "eventData.ran.event.time",
        "eventData.modem.ueStats.time",
        "eventData.access.event.time"
    ]);

    let eventTimeColumn = null;
    const dynamicColumns = [];

    Array.from(dynamicFields).forEach((fieldPath) => {
        let template = `<span>{{dataItem.${fieldPath}}}</span>`;
        let title = $translate.instant(
            "DEVICE_EVENTS_INFO_" +
            fieldPath.toUpperCase().replace(/[\.\[\]]+/g, "_")
        );

        if (fieldPath === "eventData.ran.event.range.rows") {
            template = `<span ng-repeat="row in dataItem.eventData.ran.event.range.rows">
                {{ row.distances_Mm.join(', ') }}<br/>
            </span>`;
        }

        if (
            fieldPath === "eventData.modem.ueStats.temp" ||
            fieldPath === "eventData.battery.status.temp"
        ) {
            template = `<span>{{dataItem.${fieldPath}}} °C</span>`;
            title = $translate.instant("DEVICE_EVENTS_INFO_TEMPERATURE");
        }

        if (timeFields.has(fieldPath)) {
            eventTimeColumn = {
                field: fieldPath,
                title: $translate.instant("DEVICE_EVENTS_INFO_EVENT_TIME"),
                template: function (dataItem) {
                    const time =
                        dataItem.eventData?.ran?.event?.time ||
                        dataItem.eventData?.modem?.ueStats?.time ||
                        dataItem.eventData?.access?.event?.time;

                    const dt = kendoGridUtility.getLocalDateCell(time);
                    return kendo.toString(
                        dt,
                        $translate.instant("G_DEFAULT_DATE_FORMAT")
                    );
                },
                width: "auto",
                lockable: false
            };
            return; // ⬅️ do NOT push into dynamicColumns
        }

        if (fieldPath === "eventData.access.event.outcome") {
            title = $translate.instant("STATISTICS_CONTROLLER_GRID_OUTCOME");
            template = function (dataItem) {
                const key = dataItem.eventData?.access?.event?.outcome;
                return key ? $translate.instant(key) : "";
            };
        }

        dynamicColumns.push({
            field: fieldPath,
            title,
            template,
            width: "auto",
            lockable: false
        });
    });

    return {
        eventTimeColumn,
        dynamicColumns
    };
}


    function fetchDeviceEvents() {
        $rootScope.$broadcast('showBusyIndicator', {
                id: 'deviceEventsIndicator',
                destination: '#deviceEvents',
                message: $translate.instant('G_BUSY_INDICATOR'),
                overlay: true,
                positionClass: {
                    top: '50%',
                    left: '0px',
                    right: '0px',
                }});
            deviceEventService
                .getDeviceEvents(
                    deviceExternalId,
                    $scope.filter.from,
                    $scope.filter.to,
                    $scope.filter.limit,
                    $scope.filter.category
                )
                .then((resp) => {
                    events = getGridDataFromResponse(resp);

                    const { eventTimeColumn, dynamicColumns } = generateDynamicColumns(events);

                    const timeColumn = eventTimeColumn ? [eventTimeColumn] : 
                    [
                    {
                        field: "createdAt",
                        title: $translate.instant(
                            "DEVICE_EVENTS_EVENT_CREATED"
                        ),
                        template: function(dataItem) {
                            var dt = kendoGridUtility.getLocalDateCell(dataItem.createdAt);
                            return kendo.toString(dt, $translate.instant("G_DEFAULT_DATE_FORMAT"));
                        },
                        width: "auto",
                        lockable: false,
                    }
                    ];

                    const baseColumn = [                         
                        {
                            field: "eventType",
                            title: $translate.instant(
                                "DEVICE_EVENTS_EVENT_TYPE"
                            ),
                            width: "auto",
                            lockable: false,
                        },
                    ];

                    const grid = $("#deviceEventsGrid").data("kendoGrid");
                    if (grid) {
                        grid.setOptions({
                            columns: [...timeColumn, ...baseColumn, ...dynamicColumns],
                        });
                        grid.dataSource.data(events);
                    }
                })
                .catch((error) => console.error(error))
                .finally(() => {
                    $rootScope.$broadcast(
                        "hideBusyIndicator",
                        "deviceEventsIndicator"
                    );
                });
        }

        $timeout(250).then(initController);
    }
})();
